const buildOutcomeObject=(clinicQuestions, formData, extraSymptomDetails, story, ixList, rdc, nonRdc, investigationQuestions,exceptionalRefDetails) =>
{
let outcome ={
    story:"",
    
    investigations:{
      blood:[],
      urine:[],
      stool:[],
      imaging:[],
      endoscopy:[],
      },
      investigationRequestInformation:investigationQuestions,
    clinics:{
      rdc:[],
      nonRdc:[]
      },
    clinicInfo:clinicQuestions,
    symptoms:formData.symptomList,
    SymptomDetails:extraSymptomDetails,
    exceptionalRefDetails:exceptionalRefDetails
    }
    
    outcome.story = story
    
    for (let ixType in ixList)
      {
        for (let ix in ixList[ixType])
          {
          if (ixList[ixType][ix] === true)
            {outcome.investigations[ixType].push(ix)}
          }
      }
    
    outcome.clinics.rdc.push(...rdc)
    outcome.clinics.nonRdc.push(...new Set(nonRdc))

    return outcome

    }

export default buildOutcomeObject